import React, { Component } from "react";
import {
  Button,
  Table,
  Form,
  Input,
  DatePicker,
  message,
  Select,
  Radio,
  Modal,
  Row,
  Col,
} from "antd";
import {
  _batteryTransferList,
  _exportTransferLogBattery,
  _batteryUpdateTransferStatus,
} from "@/statics/js/api";
import moment from "moment";

import { getJurisdiction } from "@/statics/js/jurisdiction";
const { Option } = Select;
const RangePicker = DatePicker.RangePicker;
class RealTimeDistributionBattery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageSize: 10, // 每页展示个数
      curPage: 1, //当前页数
      totalCount: 0, //数据总数量
      packageTransferList: [], //套餐即时分润列表
    };
    this.columns = [
      {
        title: "序号",
        dataIndex: "no",
        width: 80,
        render: (text, record, index) =>
          this.state.pageSize * (this.state.curPage - 1) + index + 1,
      },
      {
        title: "电池编号",
        align: "right",
        dataIndex: "imei",
      },
      {
        title: "订单编号",
        align: "right",
        dataIndex: "orderSn",
      },
      {
        title: "转账金额",
        align: "right",
        width: 100,
        dataIndex: "transferAmount",
        render: (text) => text && text.toFixed(2),
      },
      {
        title: "创建时间",
        width: 120,
        dataIndex: "addTime",
        render: (text) => text && moment(text).format("YYYY-MM-DD HH:mm:ss"),
      },
      {
        title: "转账时间",
        width: 120,
        dataIndex: "transferTime",
        render: (text) => text && moment(text).format("YYYY-MM-DD HH:mm:ss"),
      },
      {
        title: "转账账号",
        align: "right",
        dataIndex: "transferAccount",
      },
      {
        title: "转账流水号",
        align: "right",
        dataIndex: "tradeNo",
      },
      {
        title: "支付流水号",
        align: "right",
        dataIndex: "payTradeNo",
      },
      {
        title: "转账结果",
        width: 90,
        dataIndex: "status",
        render: (text) => (text === 0 ? "未转" : text === 1 ? "成功" : null),
      },
      {
        title: "操作",
        dataIndex: "",
        width: 100,
        key: "Action",
        fixed: "right",
        render: (text) =>
          text.checkStatus === 1 ? (
            <span>
              待审核
              <br />
              <Button
                type="link"
                onClick={this.handleReviewChange.bind(this, text.id)}
              >
                去审核
              </Button>
            </span>
          ) : text.checkStatus === 2 ? (
            "已审核"
          ) : text.checkStatus === 3 ? (
            "已拒绝"
          ) : null,
      },
    ];
  }

  // 筛选表头
  renderForm() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.handleSubmit}>
        <Row gutter={16}>
          <Col lg={6} md={12} sm={24}>
            <Form.Item label="电池编号">
              {getFieldDecorator("imei")(
                <Input allowClear placeholder="请输入" />
              )}
            </Form.Item>
          </Col>
          <Col lg={6} md={12} sm={24}>
            <Form.Item label="订单号">
              {getFieldDecorator("orderSn")(
                <Input allowClear placeholder="请输入" />
              )}
            </Form.Item>
          </Col>
          <Col lg={6} md={12} sm={24}>
            <Form.Item label="时间周期">
              {getFieldDecorator("transferTime")(
                <RangePicker format="YYYY-MM-DD" />
              )}
            </Form.Item>
          </Col>
          <Col lg={6} md={12} sm={24}>
            <Form.Item label="转账结果">
              {getFieldDecorator("status")(
                <Select placeholder="请选择" allowClear>
                  <Option value="">全部</Option>
                  <Option value={0}>未转</Option>
                  <Option value={1}>成功</Option>
                </Select>
              )}
            </Form.Item>
          </Col>
          <Col lg={6} md={12} sm={24}>
            <Form.Item label="审核状态">
              {getFieldDecorator("checkStatus")(
                <Select placeholder="请选择" allowClear>
                  <Option value="">全部</Option>
                  <Option value={1}>待审核</Option>
                  <Option value={2}>已审核 </Option>
                  <Option value={3}>已拒绝 </Option>
                </Select>
              )}
            </Form.Item>
          </Col>
          <Col lg={6} md={12} sm={24}>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                搜索
              </Button>
              <Button
                onClick={this.handleExportChange.bind(this)}
                disabled={!getJurisdiction(836)}
                title={getJurisdiction(836) ? "" : "暂无操作权限！"}
                style={{ marginLeft: 10 }}
                loading={this.state.exportload}
              >
                导出
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  }
  render() {
    const { totalCount, curPage, pageSize, packageTransferList } = this.state;
    return (
      <div>
        {getJurisdiction(835) ? (
          <div className="RealTimeDistributionBattery">
            <div className="select-form">{this.renderForm()}</div>
            <div className="content-table">
              <Table
                rowKey="id"
                bordered
                columns={this.columns}
                dataSource={packageTransferList}
                scroll={{ x: 1400, y: 500 }}
                pagination={{
                  showQuickJumper: true,
                  defaultPageSize: pageSize,
                  showSizeChanger: true,
                  onShowSizeChange: this.handlePageChange.bind(this),
                  onChange: this.handlePageChange.bind(this),
                  total: totalCount,
                  current: curPage,
                  showTotal: (totalCount) => `总共 ${totalCount} 条记录`,
                }}
              />
            </div>
          </div>
        ) : (
          "暂无操作权限！"
        )}
      </div>
    );
  }
  componentDidMount() {
    this.getPackageTransferList(
      this.state.curPage,
      this.state.pageSize,
      this.state.queryFormValues
    );
  }

  //获取套餐即时分润列表
  getPackageTransferList(curPage, pageSize, queryFormValues) {
    let params = {
      curPage: curPage,
      pageSize: pageSize,
      ...queryFormValues,
    };
    _batteryTransferList(params)
      .then((res) => {
        if (res.data.code === 200) {
          if (!res.data.data.rows.length) {
            message.warning("暂无数据！");
          }
          this.setState({
            packageTransferList: res.data.data.rows,
            totalCount: res.data.data.totalCount,
            curPage: curPage,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //分页
  handlePageChange(curPage, pageSize) {
    this.getPackageTransferList(curPage, pageSize, this.state.queryFormValues);
  }

  // 表单筛选
  handleSubmit = (e) => {
    e.preventDefault();
    const { form } = this.props;
    form.validateFields((err, values) => {
      if (err) return;
      for (let key in values) {
        if (
          values[key] === undefined ||
          values[key] === null ||
          values[key] === ""
        ) {
          delete values[key];
        }
      }
      if (values.transferTime && values.transferTime.length) {
        values.transferStart = moment(values.transferTime[0]).format(
          "YYYY-MM-DD"
        );
        values.transferEnd = moment(values.transferTime[1]).format(
          "YYYY-MM-DD"
        );
      }
      delete values.transferTime;
      this.setState({
        queryFormValues: values,
      });
      this.getPackageTransferList(1, this.state.pageSize, values);
    });
  };

  // 导出
  handleExportChange = (e) => {
    e.preventDefault();
    this.setState({
      exportload: true,
    });
    const { form } = this.props;
    form.validateFields((err, values) => {
      if (err) return;
      for (let key in values) {
        if (
          values[key] === undefined ||
          values[key] === null ||
          values[key] === ""
        ) {
          delete values[key];
        }
      }
      if (values.transferTime && values.transferTime.length) {
        values.transferStart = moment(values.transferTime[0]).format(
          "YYYY-MM-DD"
        );
        values.transferEnd = moment(values.transferTime[1]).format(
          "YYYY-MM-DD"
        );
      }
      delete values.transferTime;
      let params = {
        ...values,
      };
      _exportTransferLogBattery(params)
        .then((res) => {
          if (res.data.code === 200) {
            this.setState({
              exportload: false,
            });
            window.open(`${res.data.data}`, "_blank").focus();
          } else {
            message.warning(res.data.message);
            this.setState({
              exportload: false,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  };
  //审核交易
  handleReviewChange(id) {
    let self = this;
    let status;
    Modal.confirm({
      title: "是否审核通过该笔交易？",
      content: (
        <Radio.Group
          onChange={(e) => {
            status = e.target.value;
          }}
        >
          <Radio value={2}>通过</Radio>
          <Radio value={3}>拒绝</Radio>
        </Radio.Group>
      ),
      onOk() {
        let params = { id, status };
        _batteryUpdateTransferStatus(params)
          .then((res) => {
            if (res.data.code === 200) {
              message.success("操作成功");
              self.getPackageTransferList(
                self.state.curPage,
                self.state.pageSize,
                self.state.queryFormValues
              );
            }
          })
          .catch((err) => {
            message.warning("操作失败");
          });
      },
    });
  }
}

RealTimeDistributionBattery = Form.create({})(RealTimeDistributionBattery);
export { RealTimeDistributionBattery };
